import { Module } from 'vuex';
import { RootState } from 'frontend/types';

interface NumUsersState {
  num_users: string;
}

const numUsers: Module<NumUsersState, RootState> = {
  namespaced: true,
  state: {
    num_users: '',
  },
  getters: {},
  mutations: {
    setValue(state: NumUsersState, value: NumUsersState) {
      Object.assign(state, value);
    },
  },
};

export default numUsers;
